export default __webpack_public_path__ + "static/media/tvIcon.94298fe9.png";